import homePage from "@/views/defaultPages/HomePage.vue";
import pricingPage from "@/views/defaultPages/PricingPage.vue";
import contactPage from "@/views/defaultPages/ContactPage.vue";
import loginPage from "@/views/defaultPages/LoginPage.vue";
import setNewPassword from "@/views/defaultPages/SetNewPassword.vue";
import ModelosCatalogo from "@/views/defaultPages/ModelosCatalogo.vue";

export default [
  {
    path: "/home",
    name: "homePage",
    component: homePage,
    meta: { layout: "LayoutLogged" }
  },
  {
    path: "/pricing",
    name: "pricingPage",
    component: pricingPage,
    meta: { layout: "LayoutLogged" }
  },
  {
    path: "/contact",
    name: "contactPage",
    component: contactPage,
    meta: { layout: "LayoutLogged" }
  },
  {
    path: "/login",
    name: "loginPage",
    component: loginPage,
    alias: ["/"],
    meta: { layout: "LayoutLogin" }
  },
  {
    path: "/new-password/:token",
    name: "setNewPassword",
    component: setNewPassword,
    alias: ["/"],
    meta: { layout: "LayoutLogin" }
  },
  {
    path: "/modelos",
    name: "ModelosCatalogo",
    component: ModelosCatalogo,
    meta: { layout: "LayoutLogin" }
  }
];
